import InventoryIcon from '@mui/icons-material/Inventory'
import { Box, Divider, InputLabel, Stack, Tooltip, Typography } from '@mui/material'
import { renderColorByString } from 'components/DataGrid/renderColorByString'
import { formatCurrency } from 'components/DataGrid/operators/formatNumbers'
import { FC } from 'react'
import { useNavigate } from 'react-router-dom'
import { OrganizationTableItem } from 'types/organizations_table'
import { formatDateString } from 'utils/formatDayjsDateTime'

interface RenderProductWithIconProps {
  product: OrganizationTableItem
  route: string
  sizes?: {
    height?: number
    width?: number
    py?: number
    px?: number
    padding?: number
    gap?: number
    fontSize?: number
  }
  renderIcon?: boolean
}
const RenderProductWithIcon: FC<RenderProductWithIconProps> = ({ product, route, sizes, renderIcon }) => {
  const navigate = useNavigate()
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: renderIcon ? 'left' : 'space-between',
        height: '100%',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        width: '100%',
        maxWidth: '100%',
        fontWeight: 'bold',
        // cursor: 'pointer',
        padding: sizes?.padding ?? 0,
        py: sizes?.py ?? 0,
        px: sizes?.py ?? 0,
        gap: sizes?.gap ?? 1,
      }}
      onClick={() => navigate(route)}
    >
      {renderIcon && (
        <InventoryIcon sx={{ color: 'icon.products', height: sizes?.height ?? 18, width: sizes?.width ?? 18 }} />
      )}
      {!renderIcon && (
        <Typography
          variant="subtitle2"
          color="textSecondary"
          sx={{ textAlign: 'left', fontSize: sizes?.fontSize ?? 13 }}
        >
          Product
        </Typography>
      )}
      <Tooltip
        title={
          <Stack direction={'column'} sx={{ width: '100%', minWidth: '25vw', gap: 1 }}>
            <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between' }}>
              <InputLabel sx={{ fontSize: sizes?.fontSize ?? 12 }}>Name</InputLabel>
              <Typography noWrap sx={{ fontSize: sizes?.fontSize ?? 12 }}>
                {product?.productName}
              </Typography>
            </Box>
            <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between' }}>
              <InputLabel sx={{ fontSize: sizes?.fontSize ?? 12 }}>Status</InputLabel>
              <Typography noWrap sx={{ color: renderColorByString(product?.status), fontSize: sizes?.fontSize ?? 12 }}>
                {product?.status}
              </Typography>
            </Box>
            <Divider flexItem orientation="horizontal" />
            <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between' }}>
              <InputLabel sx={{ fontSize: sizes?.fontSize ?? 12, textAlign: 'left' }}>
                Start
                <Typography noWrap sx={{ color: 'text.primary', fontSize: sizes?.fontSize ?? 12 }}>
                  {product?.startDate ? formatDateString(product?.startDate) : '—'}
                </Typography>
              </InputLabel>
              <InputLabel sx={{ fontSize: sizes?.fontSize ?? 12, textAlign: 'right' }}>
                End
                <Typography noWrap sx={{ color: 'text.primary', fontSize: sizes?.fontSize ?? 12 }}>
                  {product?.endDate ? formatDateString(product?.endDate) : '—'}
                </Typography>
              </InputLabel>
            </Box>
            <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between' }}>
              <InputLabel sx={{ textAlign: 'left', fontSize: sizes?.fontSize ?? 12 }}>
                Price
                <Typography noWrap sx={{ textAlign: 'right', color: 'text.success', fontSize: sizes?.fontSize ?? 12 }}>
                  {product?.price && typeof product?.price !== 'number'
                    ? formatCurrency(parseFloat(product?.price))
                    : product?.price
                    ? product?.price
                    : '$0.00'}
                </Typography>
              </InputLabel>
              <InputLabel sx={{ textAlign: 'left', fontSize: sizes?.fontSize ?? 12 }}>
                Spend
                <Typography noWrap sx={{ textAlign: 'right', color: 'text.success', fontSize: sizes?.fontSize ?? 12 }}>
                  {product?.mediaSpend ? formatCurrency(product?.mediaSpend) : '$0.00'}
                </Typography>
              </InputLabel>
            </Box>
          </Stack>
        }
        arrow
        slotProps={{
          tooltip: {
            sx: {
              maxWidth: 'unset',
              width: '100%',
              minWidth: '25vw',
              borderRadius: '25px',
              bgcolor: 'background.help',
              p: 2,
            },
          },
          popper: {
            sx: { maxWidth: 'none' },
          },
        }}
      >
        <Typography
          noWrap
          variant="body2"
          sx={{
            fontSize: sizes?.fontSize ?? 12,
            textOverflow: 'ellipsis',
            overflow: 'hidden',
            '&:hover': {
              opacity: 0.7,
              cursor: 'pointer',
            },
          }}
        >
          {product?.productName}
        </Typography>
      </Tooltip>
    </Box>
  )
}

export default RenderProductWithIcon
